let pEnv = typeof process !== "undefined" && process.env ? process.env : {};
let wEnv = typeof window !== "undefined" && window.ro360 ? window.ro360 : {};

const getApiUrl = () => {
  if (window.location.hostname === "order.nextdaydumpsters.com") {
    return "https://crm.rolloff360.com/api/v1/";
  }
  if (window.location.hostname === "beta-order.nextdaydumpsters.com") {
    return "https://betacrm.rolloff360.com/api/v1/";
  }

  return wEnv.u ? wEnv.u : pEnv.VUE_APP_API_URL;
};

const getApiKey = () => {
  if (
    window.location.hostname === "order.nextdaydumpsters.com" &&
    pEnv.VUE_APP_PROD_API_KEY
  ) {
    return pEnv.VUE_APP_PROD_API_KEY;
  }

  if (
    window.location.hostname === "beta-order.nextdaydumpsters.com" &&
    pEnv.VUE_APP_BETA_API_KEY
  ) {
    return pEnv.VUE_APP_BETA_API_KEY;
  }

  return wEnv.k ? wEnv.k : pEnv.VUE_APP_API_KEY;
};

const env = {
  el: wEnv.e ? wEnv.e : "ro360",
  api: {
    key: getApiKey(),
    url: getApiUrl(),
    google: wEnv.g ? wEnv.g : pEnv.VUE_APP_GOOGLE_API_KEY
  },
  DEVELOPER_MODE: pEnv.NODE_ENV === "development",
  config: {},
  data: wEnv.d ? wEnv.d : { work_order_id: pEnv.VUE_APP_TEST_WORK_ORDER_ID }
};

env.config.axios = {
  baseURL: env.api.url,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...(env.api.key ? { token: env.api.key } : {})
  }
};

export default env;
